import { Avatar, Box, Button, Group, Stack, Text, Title, useMantineTheme } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { CONNECT_STRIPE, GET_ALL_STRIPES, SET_STRIPE_CONNECTED } from "../../services/stripes";
import InputField, { InputFieldTypes } from "../input_field";
import useStripeConnect from "../../hooks/useStripe";
import {
    ConnectAccountOnboarding,
    ConnectComponentsProvider,
} from "@stripe/react-connect-js";

export default function Stripe() {
    const [items, setItems] = useState<any[]>([]);
    const [data, setData] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [loadingItems, setLoadingItems] = useState<boolean>(false);
    const [onboardingExited, setOnboardingExited] = useState<boolean>(false);
    const [accountIdToConnect, setAccountIdToConnect] = useState<string>();
    const [connectedAccount, setConnectedAccount] = useState<any>();
    const stripeConnectInstance = useStripeConnect(accountIdToConnect);

    const theme = useMantineTheme();

    const handleChange = (dt: any) => setData((u: any) => ({ ...u, ...dt }))

    const loadData = () => {
        setLoadingItems(true)
        GET_ALL_STRIPES()
            .then((res) => {
                setItems(res);
                const con = res.find((item: any) => !!item?.data_jsonb?.connected)
                if (con) {
                    setConnectedAccount(con);
                } else {
                    setAccountIdToConnect(res[0]?.data_jsonb?.account?.id)
                }
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingItems(false)
            })
    }

    const handleSave = () => {
        setLoadingSave(true)
        CONNECT_STRIPE({ ...data })
            .then((res) => {
                loadData();
                setAccountIdToConnect(res?.data_jsonb?.account?.id);
                // window.open(res.data.accountLink.url, "_blank");
                // notifications.show({ message: "Stripe Connected", color: 'green' })
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingSave(false)
            })
    }

    React.useEffect(() => { loadData() }, [])
    React.useEffect(() => {
        if (accountIdToConnect && onboardingExited) {
            setConnectedAccount({ data: { account: { id: accountIdToConnect } } })
            try {
                SET_STRIPE_CONNECTED(accountIdToConnect);
            } catch (err) {

            }
        }
    }, [accountIdToConnect])

    return <Stack>
        <Group>
            <Avatar size={40} src="/assets/stripe.png" />
            <Title c="gray.0" order={5}>Stripe</Title>
        </Group>
        <Stack>
            {((accountIdToConnect && onboardingExited) || connectedAccount) ?
                (
                    <div className="dev-callout">
                        <p>Your connected account ID is: <code className="bold">{connectedAccount?.data_jsonb?.account?.id ?? accountIdToConnect}</code></p>
                    </div>
                ) : stripeConnectInstance
                    ? !onboardingExited && (
                        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                            <ConnectAccountOnboarding
                                onExit={() => setOnboardingExited(true)}
                            />
                        </ConnectComponentsProvider>
                    )
                    : <Group align="flex-end">
                        <Button
                            size="md"
                            onClick={items.length === 0 ? handleSave : () => setAccountIdToConnect(items[0]?.data_jsonb?.account?.id)}
                            loading={loadingSave || loadingItems}
                            color="green"
                        >Connect Stripe Account</Button>
                    </Group>}
        </Stack>
    </Stack>
}
